import React from 'react'
import Image, { ImageProps } from 'next/image'

interface NextImageProps {
    image: string
    layout: ImageProps['layout']
    width?: number | string
    height?: number | string
    altText?: string
}

export const NextImage = ({
    image,
    layout,
    width,
    height,
    altText,
}: NextImageProps) => {
    return (
        <Image
            src={image}
            alt={altText}
            width={width ?? '100%'}
            height={height ?? '100%'}
            layout={layout}
        />
    )
}

export default NextImage
